import React, { Component } from 'react';
import CalculationPropsPage from './calculation-props-html';
class CalculationProps extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <CalculationPropsPage
                />
            </div>
        )
    }
}
export default CalculationProps;